import { Label } from "../../../components/ui/label";

interface NotesSectionProps {
  t: any;
  notes: string;
  setNotes: (notes: string) => void;
}

export function NotesSection({ t, notes, setNotes }: NotesSectionProps) {
  return (
    <section className="pt-8 border-t pb-8">
      <div className="space-y-2">
        <Label>{t.editModal.previewNote}</Label>
        <textarea
          className="flex min-h-[100px] w-full rounded-md border border-neutral-200 bg-white px-3 py-2 text-sm shadow-sm placeholder:text-neutral-500 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="..."
        />
      </div>
    </section>
  );
}
